/* QueryViewRenderer.js */

"use strict";
const _ = require("lodash");
const RegExControl = require("@gluenetworks/regex_control").RegexControlComponent;
const ComboBoxControl = require("@gluenetworks/steve_ui_core").Control.OptionSelection.Single
    .ComboBox;
const FileName = require("@gluenetworks/steve_utilities").fileName;

class QueryViewRenderer {
    constructor(model) {
        this._model = model;
        this._hideViewActions();
        this._rootElem = document.createElement("query-view-gl");
        this._rootElem.component = this._model;

        this._lmContentEl = document.querySelector(".lm_content");
        this._height = document.querySelector(".lm_content").clientHeight - 120;

        this._commandList = new ComboBoxControl({options: [], showFilter: true});
        this._commandList._renderer._rootElem.classList.add("command-set");
        this._comboBoxControl = new ComboBoxControl({options: [], showFilter: true});
        this._comboBoxControl._renderer._rootElem.classList.add("device-list");
        this._regExComponent = new RegExControl({
            minLineCount: 1,
            maxLineCount: 500,
            autoResize: true,
        });

        this._fileNamer = FileName;

        this._model._parentRenderer.model.gameEditor.addViewAction({
            type: "normal",
            displayName: "Download",
            name: "downloadMatch",
            handler: (this._onDownloadClick = this._onDownloadClick.bind(this)),
        });

        this._registerListeners();
    }

    _registerListeners() {
        this._comboBoxControl.addListener(
            "UserValue",
            (this._onDeviceChange = this._onDeviceChange.bind(this))
        );
        this._commandList.addListener(
            "UserValue",
            (this._onCommandChange = this._onCommandChange.bind(this))
        );
    }
    _unregisterListeners() {
        this._comboBoxControl.removeListener("UserValue", this._onDeviceChange);
        this._commandList.removeListener("UserValue", this._onCommandChange);
    }

    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }
    get model() {
        return this.getModel();
    }
    getModel() {
        return this._model;
    }

    shutdown() {
        this._unregisterListeners();
        return Promise.resolve().then(() => {
            this._showViewActions();
            this._model._parentRenderer.model.gameEditor.removeViewAction("downloadMatch");
            this._model = undefined;
            this._rootElem = undefined;
            this._regExComponent = undefined;
            this._lmContentEl = undefined;
            this._height = undefined;
        });
    }

    _onDeviceChange(value) {
        this._model._devices
            .then((devices) => {
                this._model._device = devices.filter((device) => device.getId() === value)[0];
                this._model._setCurrentResultEntity();
                return this._model.whenModelIsReady();
            })
            .then(() => {
                const selectedCommand = this._commandList.getValue();
                this._commandList.setOptions(this._model._commandListOptions);
                this._commandList.setValue(
                    selectedCommand || this._model._commandListOptions[0].value
                );
                this.setRegExValue();
            });
    }

    _onCommandChange(val) {
        this._regExComponent.setValue(
            this._model._rawConfigBroken[val] || this._model._allConfigurations
        );
        this._regExComponent.setRegex(this._model._query);
    }

    _onDownloadClick() {
        this._model._parentRenderer.model.gameEditor.disableViewAction("downloadMatch");
        let fileConfig = {};
        const deviceName = this._model._deviceResultMap[this._model._device]
            ? this._model._deviceResultMap[this._model._device].getDeviceName()
            : this._model._deviceResultMap[this._model._device.getId()].getDeviceName();
        //let fileName = deviceName + "_AdHoc_Query_Result.zip";
        let fileName = this._fileNamer({
            solution: "DM",
            general: "AdhocQueryResults",
            specific: deviceName,
            suffix: "zip",
        });

        fileConfig[`${deviceName}.txt`] = {
            type: "text/plain",
            content: this._regExComponent.getValue(),
        };
        this._model._parentRenderer.model._steveIo.fileFactory
            .saveStringsAsZip(fileConfig, fileName)
            .finally(() => {
                this._model._parentRenderer.model.gameEditor.enableViewAction("downloadMatch");
            });
    }

    render() {
        return this.renderQueryView();
    }

    renderQueryView() {
        this._rootElem.innerHTML = "";
        return this._model.whenModelIsReady().then(() => {
            this._comboBoxControl.setOptions(this._model._deviceOptions);
            this._comboBoxControl.setSelectedOption(this._model._device);

            this._commandList.setOptions(this._model._commandListOptions);
            this._commandList.setValue(this._model._commandListOptions[0].value);

            this._regExComponent.setValue(
                this._model._rawConfigBroken[this._commandList.getValue()] ||
                    this._model._allConfigurations
            );
            this._regExComponent.setRegex(this._model._query);

            const comboBoxesContainer = document.createElement("div");
            comboBoxesContainer.classList.add("cmbbox-container-main");
            const combBoxContainer1 = document.createElement("div");
            const combBoxContainer2 = document.createElement("div");
            combBoxContainer1.classList.add("combox-container");
            combBoxContainer2.classList.add("combox-container");
            combBoxContainer1.appendChild(this._comboBoxControl.renderer.rootElement);
            combBoxContainer2.appendChild(this._commandList.renderer.rootElement);

            comboBoxesContainer.appendChild(combBoxContainer1);
            comboBoxesContainer.appendChild(combBoxContainer2);

            this._rootElem.appendChild(comboBoxesContainer);

            this._rootElem.appendChild(this._regExComponent.renderer.getRootElement());
        });
    }

    setRegExValue() {
        this._regExComponent.setValue(
            this._model._rawConfigBroken[this._commandList.getValue()] ||
                this._model._allConfigurations
        );
    }

    _hideViewActions() {
        this.model._parentRenderer._model.gameEditor.hideViewAction("editTargets");
        this.model._parentRenderer._model.gameEditor.hideViewAction("hideShowUnmatchedResults");
        this.model._parentRenderer.model.gameEditor.hideViewAction("removeUnmatchedResults");
        this.model._parentRenderer.model.gameEditor.hideViewAction("selectmatchedResults");
        this.model._parentRenderer._model.gameEditor.hideViewAction("searchButton");
        this.model._parentRenderer._model.gameEditor.hideViewAction("downloadMatches");
        this._model._parentRenderer._model._gameEditor.renderer._rootElem
            .querySelector("game-editor-view-actions-gl left-container")
            .setAttribute("style", "display: none;");
    }

    _showViewActions() {
        this.model._parentRenderer._model.gameEditor.showViewAction("editTargets");
        this.model._parentRenderer._model.gameEditor.showViewAction("hideShowUnmatchedResults");
        this.model._parentRenderer.model.gameEditor.showViewAction("removeUnmatchedResults");
        this.model._parentRenderer.model.gameEditor.showViewAction("selectmatchedResults");
        this.model._parentRenderer._model.gameEditor.showViewAction("searchButton");
        this.model._parentRenderer._model.gameEditor.showViewAction("downloadMatches");
        this._model._parentRenderer._model._gameEditor.renderer._rootElem
            .querySelector("game-editor-view-actions-gl left-container")
            .setAttribute("style", "");
        if (
            !_.isEmpty(this.model._parentRenderer._model._matchCount) ||
            this.model._parentRenderer._model._matchCount === 0
        ) {
            this.model._parentRenderer._model.gameEditor.disableViewAction("downloadMatches");
        } else {
            this.model._parentRenderer._model.gameEditor.enableViewAction("downloadMatches");
        }

        if (
            this.model._parentRenderer.model._failuresCount &&
            _.isEmpty(this.model._parentRenderer.model._matchCount)
        ) {
            this.model._parentRenderer._model.gameEditor.disableViewAction(
                "hideShowUnmatchedResults"
            );
            this.model._parentRenderer._model.gameEditor.disableViewAction(
                "removeUnmatchedResults"
            );
            this.model._parentRenderer._model.gameEditor.disableViewAction("selectmatchedResults");
        } else if (!this.model._parentRenderer.model._failuresCount) {
            this.model._parentRenderer._model.gameEditor.disableViewAction(
                "hideShowUnmatchedResults"
            );
            this.model._parentRenderer._model.gameEditor.disableViewAction(
                "removeUnmatchedResults"
            );
            this.model._parentRenderer._model.gameEditor.enableViewAction("selectmatchedResults");
        } else {
            this.model._parentRenderer._model.gameEditor.enableViewAction(
                "hideShowUnmatchedResults"
            );
            this.model._parentRenderer._model.gameEditor.enableViewAction("removeUnmatchedResults");
            this.model._parentRenderer._model.gameEditor.enableViewAction("selectmatchedResults");
        }
    }

    _filterName(name) {
        return name.replace(/\s|:|\*|-|\/|\\/g, "_");
    }
}
module.exports = QueryViewRenderer;
